export default {
    noRecordsFound: 'לא נמצאו ערכים',
    showingPage: 'מציג עמוד {0} מתוך {1} עמודים',
    show: 'הצג ',
    search: 'חפש',
    entries: ' ערכים',
    columnName: 'שם העמודה',
    insertANewColumnBefore: 'הוסף עמודה לפני',
    insertANewColumnAfter: 'הוסף עמודה אחרי',
    deleteSelectedColumns: 'מחק עמודה נבחרת',
    renameThisColumn: 'שנה שם עמודה',
    orderAscending: 'מיין בסדר עולה',
    orderDescending: 'מיין בסדר יורד',
    insertANewRowBefore: 'הוסף שורה לפני',
    insertANewRowAfter: 'הוסף שורה אחרי',
    deleteSelectedRows: 'מחק שורה נבחרת',
    editComments: 'ערוך הערות',
    addComments: 'הוסף הערות',
    comments: 'הערות',
    clearComments: 'נקה הערות',
    copy: 'העתק',
    paste: 'הדבק',
    saveAs: 'שמור בשם',
    // about: 'About',
    areYouSureToDeleteTheSelectedRows: 'מחק שורה נבחרת?',
    areYouSureToDeleteTheSelectedColumns: 'מחק עמודה נבחרת?',
    thisActionWillDestroyAnyExistingMergedCellsAreYouSure: 'האם לאשר מחיקת תאים שמוזגו?',
    thisActionWillClearYourSearchResultsAreYouSure: 'האם לנקות את תוצאות החיפוש?',
    thereIsAConflictWithAnotherMergedCell: 'קיימת סתירה בתהליך מיזוג התאים',
    invalidMergeProperties: 'הגדרות לא תקינות',
    cellAlreadyMerged: 'תא זה כבר מוזג',
    noCellsSelected: 'לא נבחרו תאים',
    id:'מספר זהות',
    active:'פעיל 0|1',
    pname:'שם פרטי',
    fname:'שם משפחה',
    email: 'אימייל',
    organization:'שם מוסד'
}